export default __webpack_public_path__ + "static/media/profit-graph-img.6d050627.svg";